import { HelpCircle, Mail } from 'lucide-react';

export function HelpTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Help & Support
        </h2>
      </div>

      {/* Help Icon and Message */}
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 bg-gradient-to-br from-[#E34290] to-purple-500 rounded-full flex items-center justify-center">
          <HelpCircle className="text-white text-2xl" />
        </div>
        <div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Need Assistance?</h3>
        </div>
      </div>

      {/* Support Email Section */}
      <div className="flex items-center gap-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
        <Mail className="h-5 w-5 text-gray-500 dark:text-gray-400" />
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
            Contact Support
          </label>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            If you need help, please reach out to our support team at
            <a href="mailto:support@jua.ai" className="ml-1 text-[#E34290] hover:underline">
              support@jua.ai
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
